import { collection, getDocs } from "firebase/firestore";
import { db } from "@/lib/firebase";
import { LIFE_OS_VARIANT_PRICING, PRODUCTS } from "@/lib/products";

const normalizeProduct = (product) => ({
  format: ["A5"],
  cover: ["Soft Paperback"],
  personalization: [],
  pageColors: [],
  variantPricing: null,
  colors: ["Cream"],
  features: [],
  bullets: [],
  inside: [],
  specs: {},
  images: [],
  category: "planners",
  plannerType: "undated",
  status: "active",
  stockStatus: "in_stock",
  stockQty: 0,
  rating: 0,
  reviews: 0,
  ...product,
});

const applyProductOverrides = (product) => {
  if (product.id !== "life-os-planner" && product.slug !== "life-os-planner") {
    return product;
  }

  return {
    ...product,
    format: ["B5"],
    cover: ["Soft Paperback", "Hard Binding"],
    personalization: ["Without Name", "With Name on Cover"],
    pageColors: ["B/W", "Coloured"],
    defaultOptions: {
      cover: "Hard Binding",
      personalization: "With Name on Cover",
      pageColor: "B/W",
      color: "Cocoa",
    },
    variantPricing: product.variantPricing || LIFE_OS_VARIANT_PRICING,
    priceINR: Number(product.priceINR || 349),
    rating: 4.9,
    reviews: 167,
    badge: "BESTSELLER",
    stockQty: 27,
    images: [
      "/product/life-os-cocoa-desk.jpg",
      "/product/life-os-cocoa-standing.jpg",
    ],
    specs: {
      ...product.specs,
      Size: "Standard B5",
      "Pages Colour": "B/W / Coloured",
      Cover: "Soft Paperback / Hard Binding",
      Binding: "Soft Paperback or Hard Binding",
    },
  };
};

export const loadCatalogProducts = async ({ includeHidden = false } = {}) => {
  try {
    const snap = await getDocs(collection(db, "products"));
    const dynamicProducts = snap.docs
      .map((doc) => applyProductOverrides(normalizeProduct({ id: doc.id, ...doc.data() })))
      .filter((product) => includeHidden || product.status === "active")
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
    const dynamicIds = new Set(dynamicProducts.map((product) => product.id));
    const staticProducts = PRODUCTS.map((product) => applyProductOverrides(normalizeProduct(product))).filter((product) => !dynamicIds.has(product.id));
    return [...dynamicProducts, ...staticProducts];
  } catch (error) {
    console.error(error);
    return PRODUCTS.map((product) => applyProductOverrides(normalizeProduct(product)));
  }
};

export const findCatalogProduct = async (slugOrId) => {
  const products = await loadCatalogProducts();
  return products.find((product) => product.slug === slugOrId || product.id === slugOrId) || products[0];
};
